export default {
  methods: {
   async render_left(data,width) {
    //颜色总数
    console.log(data);
    var productName = data.map(v=>v.productName).reverse();
    var allStoreSaleNum = data.map(v=>v.allStoreSaleNum).reverse();
    var nowStoreSaleNum = data.map(v=>v.nowStoreSaleNum).reverse();
      let option = {
        color:['#4BBFE2','#FF8A02'],
        // title: {
        //   text: '',
        //   top: 10
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        legend: {
          data: ['当前店铺','全网',],
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: 10,
          top: 10,
          containLabel: true
        },
        // dataZoom: {
        //   type: 'inside',
        //   start: 0,
        //   end: data.allCategoryName.length<20 ? 100 : 24
        // },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          position: 'top',
          axisLine:{
              lineStyle:{
                color:"#fff",
                width:1,
              }
            },
            splitLine:{
              show:false
            }
      },
      yAxis: [
        {
          type: "category",
          offset: 0,
          axisLine: {
            //这是x轴文字颜色
            lineStyle: {
              // color: "#65C6E7",
              // color: 'rgb(135,139,160)',
            },
          },
          data: productName,
          axisPointer: {
            type: "shadow",
          },
          axisTick: {
            show: false,
          },
          splitLine:{
            show:false
          },
          axisLine:{       //y轴
            show:false
  
          },
          axisLabel: {
            show: true,
            interval: 0,
            formatter: function (value) {
              return (value.length > 6 ? (value.slice(0,6)+"...") : value )
            },
            // textStyle: {
            //   color: '#FFFFFF',
            //   fontSize: 12,
            //   lineHeight: '16px'
            // }
          },
        },

          ],
      series: [
        
          {
              name: '当前店铺',
              type: 'bar',
              yAxisIndex: 0,
              data: nowStoreSaleNum,  
              barMaxWidth: 12,
              label: {   //设置柱状图上显示  对应值
                  show: true,
                  position: 'right',
                  color:'#4BBFE2'
              },
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)',
                borderRadius: [8, 8, 8, 8]
              },
              
               itemStyle: {
                  normal: {
                      barBorderRadius: [8, 8, 8, 8] // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                  },
                  
              },
          },
          {
              name: '全网',
              type: 'bar',
              yAxisIndex: 0,
              barMaxWidth: 12,
              data: allStoreSaleNum,  
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)',
                borderRadius: [8, 8, 8, 8]
              },
              label: {   //设置柱状图上显示  对应值
                  show: true,
                  position: 'right' ,
                  // offset: [100,0],
                  right: 0,
                  color:'#FF8A02'
              },
               itemStyle: {
                  normal: {
                      barBorderRadius: [8, 8, 8, 8] // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                  },
                  
              },
          },
        //    { //背景灰框
        //     name: '白框',
        //     type: 'bar',
        //     yAxisIndex: 1,
        //     barGap: '-100%',//设置-100% 则表示灰色柱状图与红色柱状图重合
        //     data: xzdata,
        //     barWidth: 21,
        //     itemStyle: {
        //         normal: {
        //             color: '#DDDDDD',
        //             barBorderRadius:[100, 100, 100, 100],
        //         },
                
        //     },
        //     z: 1  // 设置维度越高这表示覆盖低的
        // },
      ]

      };
      let $instance = this.$echarts.init(this.$refs['overview']);
      $instance.setOption(option,true);
      if(width == 1920) {
        const autoHeight = allStoreSaleNum.length * 41 + 35;
        $instance .resize({height: autoHeight})
      }
    }
  }
}